import { useDisclosure } from "@heroui/react";
import { ModalBuilder, ModalError, ModalField } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import {
  getIdFromCategoryHandbook,
  getIdFromOfficeHandbook,
  getIdFromUserHandbook,
} from "@/utils/getIdFromHandbooks.ts";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";
import { CodependentCategoryHandbook } from "../../handbooks/categoryHandbook";

interface CreateUserToLandlordTicketForm {
  subject: string;
  category: number;
  office: number;
  user: number;
  priority: "low" | "medium" | "high" | "urgent";
}

const createUserToLandlordTicketFields: ModalField[] = [
  {
    label: "hid",
    name: "user_to_landlord",
    placeholder: "-",
    type: "hidden",
  },
  {
    label: "Тема обращения",
    name: "subject",
    placeholder: "Введите тему обращения",
    type: "text",
    isRequired: true,
  },
  {
    label: "Категория",
    name: "category",
    placeholder: "",
    type: "codependent",
    deps: ["user_to_landlord"],
    element: CodependentCategoryHandbook,
    isRequired: true,
  },
  {
    label: "Офис",
    name: "office",
    placeholder: "",
    type: "office",
    isRequired: true,
  },
  {
    label: "Пользователь",
    name: "user",
    placeholder: "",
    type: "user",
    isRequired: true,
  },
  {
    label: "Приоритет",
    name: "priority",
    placeholder: "",
    type: "priority",
    isRequired: true,
  },
];

export function CreateUserToLandlordTicketModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: CreateUserToLandlordTicketForm) => {
    return new Promise<boolean>((resolve) => {
      Promise.all([
        getIdFromUserHandbook(String(data.user)),
        getIdFromOfficeHandbook(String(data.office)),
        getIdFromCategoryHandbook(String(data.category)),
      ])
        .then(([user, office, category]) => {
          return api.tickets.create({
            subject: data.subject,
            type: "user_to_landlord",
            category: Number(category),
            status: "open",
            priority: data.priority,
            office_id: Number(office),
            creator_user_id: Number(user),
          });
        })
        .then(() => {
          loadHandbooks({ handbooks: ["ticketCategories"] });
          disclosure.onClose();
          toast.success("Тикет успешно создан");
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание тикета к арендодателю"
      modalErrors={modalErrors}
      fields={createUserToLandlordTicketFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      defaultValues={{
        user_to_landlord: "user_to_landlord",
      }}
    />
  );
}
